import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { useParams } from 'react-router-dom';

import Page from '@/components/Page/Page';
import ContractLinesContainer from './ContractLines/ContractLines.container';
import ContractTitleContainer from './ContractTitle/ContractTitle.container';
import RightPanelContainer from './RightPanel/RightPanel.container';
import { rightsidePanel_isOpen } from './RightPanel/RightPanel.state';
import TagTabs from '@/components/common/TagTabs/TagTabs';
import { getContractDetailsTabs } from './ContractHeaders/components/contractDetailsTabs';
import useGetContractDetails from '@/hooks/contract/useGetContractDetails.hook';

export default function ContractDetails() {
  const setIsOpen = useSetRecoilState(rightsidePanel_isOpen);
  const { contractId }: { contractId: UUID } = useParams();
  const { contract, isContractLoading } = useGetContractDetails(contractId);

  useEffect(() => () => {
    setIsOpen(false);
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  return (
    <>
      <Page
        pageTitle="Contract Details"
        padding={true}
        withWhiteBackground={true}
      >
        <ContractTitleContainer
          key={location.pathname}
          contract={contract}
          isContractLoading={isContractLoading} />
        <div className="mt-10">
          <TagTabs tabs={getContractDetailsTabs()} />
        </div>
        <ContractLinesContainer contract={contract} />
        <RightPanelContainer />
      </Page>
    </>
  );
}
